/**
 * Wrap all admin children in this special admin layout
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import admin components
import StudyDashTopNav from './StudyDashTopNav.js.jsx';

export default class AdminLayout extends Base {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="master-layout admin-layout">
        <StudyDashTopNav/>
        <div className="body -admin-body">
          {this.props.children}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// modules/study/components/StudyDashboardLayout.js.jsx